import React from 'react'
import getTransitionStyle from '../utils/getTransitionStyle'
import Footer from '../components/Footer'
import { HelmetDatoCms } from 'gatsby-source-datocms'
import Menu from '../components/Menu'
import NewsCategories from '../components/NewsCategories'
import PageAnimations from '../components/PageAnimations'
import Img from 'gatsby-image'
import ResponsiveEmbed from 'react-responsive-embed'
import Masonry from 'react-masonry-component';
import Link from '../components/IntlLink'
import close from "../images/round-close.svg"
import smoothScroll from 'smoothscroll';

export default class News extends React.Component {
  constructor(props) {
    super(props);
    this.state = {lightboxImage: null}
  }

  componentWillMount() {
    if (this.props.location.hash === "#title") {
      setTimeout(() => {
        smoothScroll(this.newsTitle, 1000)
      }, 2000)
    }
  }

  handleOpenLightbox(image, e) {
    e.preventDefault()
    this.setState({lightboxImage: image})
  }

  handleCloseLightbox(e) {
    e.preventDefault()
    this.setState({lightboxImage: null})
  }

  renderGalleryImage(image, index, sectionAppears) {
    return (
      <Link
        key={image.id}
        className="masonry__item--news"
        style={sectionAppears}
        to="#"
        onClick={this.handleOpenLightbox.bind(this, image)}
      >
        <Img
          key={image.url + index}
          sizes={image.sizes}
          title={image.title}
          alt={image.alt}
        />
      </Link>
    );
  }

  renderVideo(video) {
    const { width, height, providerUid, provider, url } = video
    var embedUrl = ''
    if (provider === 'youtube') {
      embedUrl = `//www.youtube.com/embed/${providerUid}?rel=0;autoplay=1`
    } else if (provider === 'vimeo') {
      embedUrl = `//player.vimeo.com/video/${providerUid}?title=0&amp;byline=0&amp;portrait=0;autoplay=1`
    } else if (provider === 'facebook') {
      embedUrl = `//www.facebook.com/plugins/video.php?href=${video.url}&autoplay=1&mute=0`
    }
    return (
      <div className="wrap">
        <ResponsiveEmbed
          width={width}
          height={height}
          src={embedUrl}
          allowFullScreen
          ratio='16:9'
        />
      </div>
    )
  }

  render() {
    const { data } = this.props

    const {
      data: {
        news: {
          title,
          date,
          video,
          abstract,
          themeColor,
          newsGallery,
          newsTags,
          text,
          seo
        }
      }
    } = this.props;

    const allCategories = data.categories.edges.map((n) => n.node)

    const status = this.props.transition ? this.props.transition.status : "entering"
    const menuStyle = getTransitionStyle(status, 200, 2000, 'menuStyle')
    const timeout = 800

    const sectionAppears = getTransitionStyle(
      status, timeout, 1000, 'pageAppearsFromBottom'
    )
    return (
      <div className="page" style={{ backgroundColor: "#FFF" }}>
        <HelmetDatoCms
          seo={seo}
          favicon={data.site.favicon}
        />

        <Menu
          style={menuStyle}
          hasWhiteLogo={false}
          data={data}
        />

        <PageAnimations
          status={status}
          timeout={timeout}
          delay={timeout}
          color="#FFF"
        />

        <div className="news__nav" style={sectionAppears}>
          <NewsCategories allCategories={allCategories}/>
        </div>

        <div className="wrap" ref={(el) => this.newsTitle = el} style={sectionAppears}>
          <div className="page__subtitle--news">
            {date}
          </div>
          <h1 className="page__title--dark">
            {title}
          </h1>
            {
              abstract &&
                <div className="page__textbox" style={sectionAppears}>
                  <div
                    className="page__text--news"
                    dangerouslySetInnerHTML={{ __html: abstract.markdown.html }}
                  />
                </div>
            }
        </div>

        { video && this.renderVideo(video) }

        <div className="wrap">
          <Masonry
            className="masonry--news"
            style={sectionAppears}
          >
            { newsGallery.map((image, index) =>
              this.renderGalleryImage(image, index, sectionAppears)) }
          </Masonry>
        </div>

        <div className="page__textbox" style={sectionAppears}>
          <div className="wrap">
            <div
              className="page__text--news"
              dangerouslySetInnerHTML={{ __html: text.markdown.html }}
            />
            <div className="page__text" style={sectionAppears}>
            {
              newsTags.map(tag =>
                <Link to={`/tag/${tag.slug}`}
                  key={tag.id}
                  className="news__tag">
                    {`#${tag.title.toLowerCase().split(" ").join("")}  `}
                </Link>
              )
            }
            </div>
          </div>
        </div>
        {
          this.state.lightboxImage &&
            <div className="news__lightbox">
              <span className="news__lightbox__close" onClick={this.handleCloseLightbox.bind(this)}>
                <img src={ close }/>
              </span>
              <img
                className="news__lightbox__image"
                src={this.state.lightboxImage.url}
                title={this.state.lightboxImage.title}
                alt={this.state.lightboxImage.alt}
              />
            </div>
        }
        <Footer data={data} />
      </div>
    );
  }
}

export const query = graphql`
  query NewsQuery($slug: String!, $locale: String!) {
    site: datoCmsSite {
      favicon: faviconMetaTags {
        ...GatsbyDatoCmsFaviconMetaTags
      }
    }

    news: datoCmsNews(slug: { eq: $slug }, locale: { eq: $locale }) {
      id
      title
      seo: seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      abstract: abstractNode {
        markdown: childMarkdownRemark {
          html
        }
      }
      date
      slug
      text: textNode {
        markdown: childMarkdownRemark {
          html
        }
      }
      categories {
        title
        slug
      }
      newsTags {
        id
        title
        slug
      }
      video {
        provider
        providerUid
        height
        width
        url
      }
      newsGallery {
        id
        url
        width
        height
        alt
        title
        sizes(maxWidth: 1100, imgixParams: { fm: "jpg", auto: "compress" }) {
          ...GatsbyDatoCmsSizes
        }
      }
    }

    categories: allDatoCmsNewsCategory(filter: { locale: { eq: $locale } }) {
      edges {
        node {
          id
          title
          slug
        }
      }
    }

    menuHomepage:           datoCmsHomepage(locale: { eq: $locale })           { menuTitle themeColor { hex } }
    menuInterchangeability: datoCmsInterchangeability(locale: { eq: $locale }) { menuTitle themeColor { hex } slug }
    menuPhilosophy:         datoCmsPhilosophy(locale: { eq: $locale })         { menuTitle themeColor { hex } slug }
    menuNews:               datoCmsNewsHome(locale: { eq: $locale })           { menuTitle themeColor { hex } slug }
    menuAbout:              datoCmsAbout(locale: { eq: $locale })              { menuTitle themeColor { hex } slug }
    menuContact:            datoCmsContact(locale: { eq: $locale })            { menuTitle themeColor { hex } slug }
    menuCatalog:            datoCmsCatalog(locale: { eq: $locale })            { menuTitle themeColor { hex } slug }
    menuDownload:           datoCmsDownloadArea(locale: { eq: $locale })       { menuTitle themeColor { hex } slug }
    menuDesigners:          datoCmsDesignersPage(locale: { eq: $locale })      { menuTitle themeColor { hex } slug }
    menuFooter:             datoCmsFooter                                      { facebook instagram twitter youtube pinterest companyName address: addressNode { markdown: childMarkdownRemark { html } } googleMapsUrl phoneNumber faxNumber vat emailAddress newsletterTitle newsletterDescription}
  }
`



// WEBPACK FOOTER //
// ./src/templates/news.js